/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RailiumEinsatz } from './RailiumEinsatz';
import {
    RailiumEinsatzFromJSON,
    RailiumEinsatzFromJSONTyped,
    RailiumEinsatzToJSON,
} from './RailiumEinsatz';

/**
 * 
 * @export
 * @interface AehnlichkeitsErgebnis
 */
export interface AehnlichkeitsErgebnis {
    /**
     * 
     * @type {RailiumEinsatz}
     * @memberof AehnlichkeitsErgebnis
     */
    railiumEinsatz?: RailiumEinsatz;
    /**
     * 
     * @type {number}
     * @memberof AehnlichkeitsErgebnis
     */
    score?: number;
}

/**
 * Check if a given object implements the AehnlichkeitsErgebnis interface.
 */
export function instanceOfAehnlichkeitsErgebnis(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AehnlichkeitsErgebnisFromJSON(json: any): AehnlichkeitsErgebnis {
    return AehnlichkeitsErgebnisFromJSONTyped(json, false);
}

export function AehnlichkeitsErgebnisFromJSONTyped(json: any, ignoreDiscriminator: boolean): AehnlichkeitsErgebnis {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'railiumEinsatz': !exists(json, 'railiumEinsatz') ? undefined : RailiumEinsatzFromJSON(json['railiumEinsatz']),
        'score': !exists(json, 'score') ? undefined : json['score'],
    };
}

export function AehnlichkeitsErgebnisToJSON(value?: AehnlichkeitsErgebnis | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'railiumEinsatz': RailiumEinsatzToJSON(value.railiumEinsatz),
        'score': value.score,
    };
}

